import { LayoutMetaData } from "../../layout-meta-data/layout-meta-data";
import { Expose, Type } from '@nts/std/serialization';

export class CreateDraftLayoutDataDto {
    @Expose()
    @Type(() => LayoutMetaData)
    metaData: LayoutMetaData;
}

